import { TEAMS_LINK, TeamsLogo } from "@/lib";
import { motion } from "framer-motion";
import { Zap, CreditCard, MessageCircle, ShoppingBag, ArrowRight } from "lucide-react"; // Added ShoppingBag, ArrowRight

export default function ProductSection() {
  return (
    <section id="products" className="py-20 sm:py-24 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* --- Refined Visual Element (Left) --- */}
          <motion.div
            className="flex justify-center"
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 0.5 }}
          >
            <div className="relative w-[300px] h-[300px] flex items-center justify-center">
              {/* Outer Glow / Background Element - Subtle and expansive */}
              <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-green-700 to-sky-700 opacity-20 blur-xl animate-pulse-light"></div>

              {/* Central Tablet/Phone-like Device Frame */}
              <div className="relative w-[240px] h-[280px] bg-gray-800 rounded-2xl shadow-2xl border border-gray-700 overflow-hidden flex flex-col justify-end p-4">
                {/* Simulated Chat Interface */}
                <div className="absolute top-4 left-4 right-4 bg-gray-700 h-16 rounded-xl flex items-center p-2 shadow-inner">
                  <MessageCircle className="w-8 h-8 text-green-400 mr-2" />
                  <span className="text-gray-300 font-medium">Chat Commerce AI</span>
                </div>

                {/* Simulated Product Card / Message */}
                <div className="w-full bg-blue-600/80 p-3 rounded-lg self-end mb-2 shadow-md">
                  <p className="text-white text-sm font-semibold">"I'd like to order..."</p>
                </div>
                {/* Simulated Payment Confirmation */}
                <div className="w-full bg-green-500/80 p-3 rounded-lg self-end shadow-md flex items-center justify-between">
                  <CreditCard className="w-5 h-5 text-white mr-2" />
                  <span className="text-white text-sm font-semibold">Payment Confirmed!</span>
                  <ArrowRight className="w-4 h-4 text-white" />
                </div>
              </div>

              {/* Overlaying Connectivity/Integration Icon */}
              <div className="absolute top-0 right-0 p-2 bg-gradient-to-br from-sky-500 to-indigo-600 rounded-full shadow-lg -mt-4 -mr-4">
                <ShoppingBag className="w-8 h-8 text-white" />
              </div>

              {/* Small "AI" indicator */}
              <div className="absolute bottom-0 left-0 p-1 px-3 bg-gray-700 rounded-tr-xl text-xs text-green-300 font-semibold shadow-inner">AI</div>
            </div>
          </motion.div>

          {/* --- Text Content (Right) --- */}
          <motion.div
            className="lg:pl-8"
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 0.5 }}
          >
            <span className="text-sm font-semibold uppercase text-green-400">
              End-to-End Conversational Commerce Engine
            </span>
            <h2 className="mt-2 text-3xl font-extrabold tracking-tight text-white sm:text-5xl">
              Instant Ordering & Secure Payments on WhatsApp and Messenger
            </h2>
            <p className="mt-6 text-xl text-gray-300">
              The future of e-commerce is conversational. Our system harnesses the power of your existing chat channels on <strong className="bg-blue-300 text-gray-900 px-1 rounded">
                WhatsApp</strong> and <strong className="bg-blue-300 text-gray-900 px-1 rounded">Meta platforms</strong> to create a fully automated sales ecosystem. It seamlessly manages your product catalog, facilitates order placement, and integrates secure, in-chat payment processing, providing small and medium businesses with a direct, streamlined path from chat to conversion.
            </p>

            {/* CTA: Focus on Product Demo/Details */}
            <motion.a
              href="#" // Replace with your actual Product Demo/Details link
              className="mt-8 inline-flex items-center bg-green-600 text-white px-8 py-4 rounded-xl text-lg font-semibold shadow-2xl shadow-green-600/50 transition-all duration-300 transform"
              whileHover={{ scale: 1.05, backgroundColor: '#15803d', y: -2 }}
              whileTap={{ scale: 0.95 }}
            >
              <Zap className="w-5 h-5 mr-3" />
              Request a Live Demo
            </motion.a>
            <p className="mt-4 text-sm text-gray-400">Integrates with WhatsApp Business API, Facebook Messenger & Instagram.</p>

          </motion.div>
        </div>
      </div>
    </section>
  );
}